module.exports = __webpack_public_path__ + "img/plant.f552928a.svg";